import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { AccountDataDTO } from '../classes/user-account.dto';
import { MedicalDataDTO } from '../classes/api-dto';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private appointmentsSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private appointmentsObservable: Observable<any> = this.appointmentsSubject.asObservable();
  private sessioIdSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private sessionIdObservable: Observable<any> = this.sessioIdSubject.asObservable();
  private medicalDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private medicalDataObservable: Observable<any> = this.medicalDataSubject.asObservable();
  private accountDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private accountDataObservable: Observable<any> = this.accountDataSubject.asObservable();
  private accountDataFromSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private accountDataFromObservable: Observable<any> = this.accountDataFromSubject.asObservable();
  private companyIdSubject = new BehaviorSubject<string | undefined>(undefined);
  companyId$ = this.companyIdSubject.asObservable();
  private activationCodeSubject = new BehaviorSubject<any>(undefined);
  activationCode$ = this.activationCodeSubject.asObservable();
  private companyConfigSubject = new BehaviorSubject<any>('');
  config$ = this.companyConfigSubject.asObservable();
  private changeNavbarSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private changeNavbarObservable: Observable<any> = this.changeNavbarSubject.asObservable();
  private datesSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private datesObservable: Observable<any> = this.datesSubject.asObservable();
  private homeAssistanceUrlSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private homeAssistanceUrlObservable: Observable<any> = this.homeAssistanceUrlSubject.asObservable();
  private calendarConfigUrlSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private calendarConfigUrlObservable: Observable<any> = this.calendarConfigUrlSubject.asObservable();

  constructor() {}

  public setAppointments(appointments: any): void {
    this.appointmentsSubject.next(appointments);
  }

  public getAppointments(): Observable<any> {
    return this.appointmentsObservable;
  }

  public setSessionId(sessionId: any): void {
    this.sessioIdSubject.next(sessionId);
  }

  public getSessionId(): Observable<any> {
    return this.sessionIdObservable;
  }

  public setMedicalData(medicalData: MedicalDataDTO): void {
    this.medicalDataSubject.next(medicalData);
  }

  public getMedicalData(): Observable<MedicalDataDTO> {
    return this.medicalDataObservable;
  }

  public getAppointmentById(id: string): Observable<any> {
    return this.appointmentsObservable.pipe(
      map((data: any) => {
        return data?.find((appointment: any): boolean => appointment.missionId === id);
      })
    );
  }

  public setAccountData(accountData: AccountDataDTO): void {
    this.accountDataSubject.next(accountData);
  }

  public getAccountData(): Observable<AccountDataDTO> {
    return this.accountDataObservable;
  }

  public setAccountDataFrom(from: boolean): void {
    this.accountDataFromSubject.next(from);
  }

  public getAccountDataFrom(): Observable<boolean> {
    return this.accountDataFromObservable;
  }

  setCompanyId(companyId: string): void {
    this.companyIdSubject.next(companyId);
  }

  getCompanyId(): string | undefined {
    return this.companyIdSubject.value;
  }

  setActivationCode(activationCode: any): void {
    this.activationCodeSubject.next(activationCode);
  }

  getActivationCode(): any {
    return this.activationCodeSubject.value;
  }

  setConfig(config: any): void {
    this.companyConfigSubject.next(config);
    this.setThemeColors(config.colors);
  }

  getConfig(): any {
    return this.companyConfigSubject;
  }

  private setThemeColors(colors: any): void {
    if (!colors) return;
    Object.keys(colors).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, colors[key]);
    });
  }

  public setChangeNavbar(change: boolean): void {
    this.changeNavbarSubject.next(change);
  }

  public getChangeNavbar(): Observable<boolean> {
    return this.changeNavbarObservable;
  }

  public setDatesByModify(dates: any): void {
    this.datesSubject.next(dates);
  }

  public getDatesByModify(): Observable<any> {
    return this.datesObservable;
  }

  public setURLS(v: any): void {
    if (v.calendarConfigUrl) {
      this.calendarConfigUrlSubject.next(v.calendarConfigUrl);
    }
    if (v.companyCustomizations.homeAssistanceUrl) {
      this.homeAssistanceUrlSubject.next(v.companyCustomizations.homeAssistanceUrl);
    }
  }

  public getCalendarUrl(): Observable<string> {
    return this.calendarConfigUrlObservable;
  }

  public getHomeAssistanceUrl(): Observable<string> {
    return this.homeAssistanceUrlObservable;
  }

  resetData() {
    this.accountDataSubject.next('');
    this.accountDataFromSubject.next('');
    this.changeNavbarSubject.next('');
  }
}
